/**
 * Created by Daniela on 23/01/2017.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {editRoute, newRoute, detailRoute} from "../../shared/services/data.service";
import { TanqueListComponent } from "./tanque-list/tanque-list.component";
import { TanqueFormComponent } from "./tanque-form/tanque-form.component";
import { TanqueEstoqueListComponent } from "./tanque-estoque-list/tanque-estoque-list.component";
import {tanquesEstoqueRoute, tanquesMovimentacaoRoute} from "./shared/data.service";
import { TanqueMovimentacaoDetailComponent } from "./tanque-movimentacao-detail/tanque-movimentacao-detail.component";
import { TanqueMovimentacaoFormComponent } from "./tanque-movimentacao-form/tanque-movimentacao-form.component";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class TanquesRoutingModule {}

export const tanquesRoutes: any[] = [
    {
        path: '',
        component: TanqueListComponent
    },{
        path: editRoute + '/:id',
        component: TanqueFormComponent
    },{
        path: newRoute,
        component: TanqueFormComponent
    },{
        path: tanquesEstoqueRoute,
        component: TanqueEstoqueListComponent
    },{
        path: tanquesMovimentacaoRoute,
        children: [
            {
                path: editRoute + '/:id',
                component: TanqueMovimentacaoFormComponent
            },{
                path: newRoute,
                component: TanqueMovimentacaoFormComponent
            },{
                path: detailRoute + '/:id',
                component: TanqueMovimentacaoDetailComponent,
            }
        ]
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tanques/tanques-routing.module.ts
 **/